import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const MenuItems = ({
  toggleSaveOcrData,
  mode,
  handleLogout
}) => {
  return [
    <MenuItem
      key="clear"
      primaryText="Clear"
      onClick={() => window.location.replace('/')}
    />,
    <MenuItem
      key="mode"
      primaryText={
        mode === 'Legacy' ? 'Normal Mode' : 'Legacy Mode'
      }
      onClick={() =>
        mode === 'Legacy'
          ? window.location.replace('/?service=qr')
          : window.location.replace('/')
      }
    />,
    <MenuItem
      key="logout"
      primaryText="Logout"
      onClick={handleLogout}
    />
  ]
}

export default MenuItems



// WEBPACK FOOTER //
// ./src/components/MenuItems.js